export default __webpack_public_path__ + "static/media/TheWalkingDead.94c45b17.jpg";